import { render, staticRenderFns } from "./CreateAccrual.vue?vue&type=template&id=64409bb6&scoped=true"
import script from "./CreateAccrual.vue?vue&type=script&lang=js"
export * from "./CreateAccrual.vue?vue&type=script&lang=js"
import style0 from "./CreateAccrual.vue?vue&type=style&index=0&id=64409bb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64409bb6",
  null
  
)

export default component.exports